import { render, staticRenderFns } from "./AdminBoardDashboard.vue?vue&type=template&id=e68630d6&scoped=true"
import script from "./AdminBoardDashboard.vue?vue&type=script&lang=js"
export * from "./AdminBoardDashboard.vue?vue&type=script&lang=js"
import style0 from "./AdminBoardDashboard.vue?vue&type=style&index=0&id=e68630d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e68630d6",
  null
  
)

export default component.exports